import React from 'react'
import { Alert, AlertTitle, Box, Button } from '@mui/material'
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded'
import { openCrispChat } from '../../helpers/useCrisp'
import { controlRoomLimitCopy } from '../../helpers/controlRoomCapacity'

// Inline explanation shown by the control-room start / reopen dialogs when
// the server refuses because the concurrent control-room capacity is in use,
// or (Premium) the month's control-room hours are used up.
// `limitInfo` is the 403 payload ({ limitType, used, limit, ... }). The button
// sits under the text (not as an Alert action) so it fits narrow dialogs and
// phones.
const ConcurrentRoomLimitAlert = ({ limitInfo, sx }) => {
  const { title, message } = controlRoomLimitCopy(limitInfo)
  return (
  <Alert severity="warning" sx={{ borderRadius: 3, ...sx }}>
    <AlertTitle sx={{ fontWeight: 800 }}>{title}</AlertTitle>
    {message}
    <Box mt={1}>
      <Button
        color="inherit"
        size="small"
        variant="outlined"
        startIcon={<SupportAgentRoundedIcon />}
        onClick={() => openCrispChat()}
        sx={{ textTransform: 'none', fontWeight: 800, borderRadius: 999 }}
      >
        Contact AmbuNet
      </Button>
    </Box>
  </Alert>
  )
}

export default ConcurrentRoomLimitAlert
